import {injectReducer} from '../../store/reducers'
import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'deprecated-lead-management-ignore',
  onEnter: isLoggedIn(store),
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      // const HomeView = require('./components/HomeView').default;
      const LeadManagement = require('./containers/LeadManagementContainer').default
      const {
        leadManagementFilterReducer, walkInInterestLeadsReducer, customerInterestLeadsReducer, walkInInterestFormReducer
        , endlessAisleFormReducer
      } = require('./modules/leadManagement')
      const {loadStoreOptionsReducer, loadStoreTagOptionsReducer} = require('../SalesAnalytics/modules/salesAnalytics');

      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, {key: 'leadManagementFilter', reducer: leadManagementFilterReducer})
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})
      injectReducer(store, {key: 'storeTagOptions', reducer: loadStoreTagOptionsReducer})
      injectReducer(store, {key: 'walkInInterestLeads', reducer: walkInInterestLeadsReducer})
      injectReducer(store, {key: 'customerInterestLeads', reducer: customerInterestLeadsReducer})
      injectReducer(store, {key: 'walkInInterestForm', reducer: walkInInterestFormReducer})
      injectReducer(store, {key: 'endlessAisleInterestForm', reducer: endlessAisleFormReducer})

      /*  Return getComponent   */
      cb(null, LeadManagement)

      /* Webpack named bundle   */
    }, 'HomeView')
  }
})



// WEBPACK FOOTER //
// ./src/routes/LeadManagement/index.js